export interface Prayer {
  id: string;
  title: string;
  category: string;
  subtitle?: string;
  text: string[];
  traditional?: string[];
  responses?: string[];
  closing?: string[];
}

export const PRAYER_CATEGORIES = [
  'All',
  'Basic Prayers',
  'Marian Prayers',
  'Devotional Prayers',
  'Daily Prayers',
  'Rosary',
];

export const PRAYERS: Prayer[] = [
  {
    id: 'sign-of-the-cross',
    title: 'Sign of the Cross',
    category: 'Basic Prayers',
    text: [
      'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
    ],
  },
  {
    id: 'our-father',
    title: 'Our Father',
    category: 'Basic Prayers',
    subtitle: 'The Lord\'s Prayer',
    text: [
      'Our Father, who art in heaven, hallowed be thy name; thy kingdom come; thy will be done on earth as it is in heaven.',
      'Give us this day our daily bread; and forgive us our trespasses as we forgive those who trespass against us; and lead us not into temptation, but deliver us from evil.',
      'Amen.',
    ],
  },
  {
    id: 'hail-mary',
    title: 'Hail Mary',
    category: 'Marian Prayers',
    text: [
      'Hail Mary, full of grace, the Lord is with thee; blessed art thou among women, and blessed is the fruit of thy womb, Jesus.',
      'Holy Mary, Mother of God, pray for us sinners, now and at the hour of our death.',
      'Amen.',
    ],
  },
  {
    id: 'glory-be',
    title: 'Glory Be',
    category: 'Basic Prayers',
    subtitle: 'Doxology',
    text: [
      'Glory be to the Father, and to the Son, and to the Holy Spirit.',
      'As it was in the beginning, is now, and ever shall be, world without end.',
      'Amen.',
    ],
  },
  {
    id: 'apostles-creed',
    title: 'Apostles\' Creed',
    category: 'Basic Prayers',
    text: [
      'I believe in God, the Father almighty, Creator of heaven and earth, and in Jesus Christ, his only Son, our Lord, who was conceived by the Holy Spirit, born of the Virgin Mary, suffered under Pontius Pilate, was crucified, died and was buried; he descended into hell; on the third day he rose again from the dead; he ascended into heaven, and is seated at the right hand of God the Father almighty; from there he will come to judge the living and the dead.',
      'I believe in the Holy Spirit, the holy catholic Church, the communion of saints, the forgiveness of sins, the resurrection of the body, and life everlasting.',
      'Amen.',
    ],
  },
  {
    id: 'nicene-creed',
    title: 'Nicene Creed',
    category: 'Basic Prayers',
    text: [
      'I believe in one God, the Father almighty, maker of heaven and earth, of all things visible and invisible.',
      'I believe in one Lord Jesus Christ, the Only Begotten Son of God, born of the Father before all ages. God from God, Light from Light, true God from true God, begotten, not made, consubstantial with the Father; through him all things were made. For us men and for our salvation he came down from heaven, and by the Holy Spirit was incarnate of the Virgin Mary, and became man. For our sake he was crucified under Pontius Pilate, he suffered death and was buried, and rose again on the third day in accordance with the Scriptures. He ascended into heaven and is seated at the right hand of the Father. He will come again in glory to judge the living and the dead and his kingdom will have no end.',
      'I believe in the Holy Spirit, the Lord, the giver of life, who proceeds from the Father and the Son, who with the Father and the Son is adored and glorified, who has spoken through the prophets.',
      'I believe in one, holy, catholic and apostolic Church. I confess one Baptism for the forgiveness of sins and I look forward to the resurrection of the dead and the life of the world to come.',
      'Amen.',
    ],
  },
  {
    id: 'hail-holy-queen',
    title: 'Hail, Holy Queen',
    category: 'Marian Prayers',
    subtitle: 'Salve Regina',
    text: [
      'Hail, holy Queen, Mother of mercy, hail, our life, our sweetness and our hope. To thee do we cry, poor banished children of Eve: to thee do we send up our sighs, mourning and weeping in this vale of tears.',
      'Turn then, most gracious Advocate, thine eyes of mercy toward us, and after this our exile, show unto us the blessed fruit of thy womb, Jesus.',
      'O clement, O loving, O sweet Virgin Mary!',
    ],
    responses: [
      'V. Pray for us, O holy Mother of God.',
      'R. That we may be made worthy of the promises of Christ.',
    ],
  },
  {
    id: 'act-of-contrition',
    title: 'Act of Contrition',
    category: 'Devotional Prayers',
    text: [
      'My God, I am sorry for my sins with all my heart. In choosing to do wrong and failing to do good, I have sinned against you whom I should love above all things. I firmly intend, with your help, to do penance, to sin no more, and to avoid whatever leads me to sin.',
      'Our Savior Jesus Christ suffered and died for us. In his name, my God, have mercy.',
      'Amen.',
    ],
  },
  {
    id: 'angelus',
    title: 'The Angelus',
    category: 'Marian Prayers',
    text: [
      'The Angel of the Lord declared unto Mary:',
      'And she conceived of the Holy Spirit.',
      '',
      'Hail Mary, full of grace, the Lord is with thee; blessed art thou among women, and blessed is the fruit of thy womb, Jesus. Holy Mary, Mother of God, pray for us sinners, now and at the hour of our death. Amen.',
      '',
      'Behold the handmaid of the Lord:',
      'Be it done unto me according to Thy word.',
      '',
      'Hail Mary, full of grace...',
      '',
      'And the Word was made Flesh:',
      'And dwelt among us.',
      '',
      'Hail Mary, full of grace...',
      '',
      'Pray for us, O Holy Mother of God,',
      'that we may be made worthy of the promises of Christ.',
    ],
    closing: [
      'Pour forth, we beseech Thee, O Lord, Thy grace into our hearts; that we, to whom the incarnation of Christ, Thy Son, was made known by the message of an angel, may by His Passion and Cross be brought to the glory of His Resurrection, through the same Christ Our Lord.',
      'Amen.',
    ],
  },
  {
    id: 'memorare',
    title: 'Memorare',
    category: 'Marian Prayers',
    text: [
      'Remember, O most gracious Virgin Mary, that never was it known that anyone who fled to thy protection, implored thy help, or sought thy intercession was left unaided.',
      'Inspired with this confidence, I fly to thee, O Virgin of virgins, my Mother; to thee do I come; before thee I stand, sinful and sorrowful. O Mother of the Word Incarnate, despise not my petitions, but in thy mercy hear and answer me.',
      'Amen.',
    ],
  },
  {
    id: 'anima-christi',
    title: 'Anima Christi',
    category: 'Devotional Prayers',
    subtitle: 'Soul of Christ',
    text: [
      'Soul of Christ, sanctify me.',
      'Body of Christ, save me.',
      'Blood of Christ, inebriate me.',
      'Water from the side of Christ, wash me.',
      'Passion of Christ, strengthen me.',
      'O good Jesus, hear me.',
      'Within Thy wounds hide me.',
      'Suffer me not to be separated from Thee.',
      'From the malignant enemy defend me.',
      'In the hour of my death call me.',
      'And bid me come to Thee,',
      'That with Thy saints I may praise Thee',
      'Forever and ever.',
      'Amen.',
    ],
  },
  {
    id: 'divine-mercy',
    title: 'Divine Mercy Chaplet',
    category: 'Devotional Prayers',
    text: [
      'Eternal Father, I offer You the Body and Blood, Soul and Divinity of Your dearly beloved Son, Our Lord Jesus Christ, in atonement for our sins and those of the whole world.',
    ],
    responses: [
      'For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
    ],
    traditional: [
      '(On the Our Father beads)',
      'Eternal Father, I offer You the Body and Blood, Soul and Divinity of Your dearly beloved Son, Our Lord Jesus Christ, in atonement for our sins and those of the whole world.',
      '',
      '(On the Hail Mary beads)',
      'For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
    ],
  },
  {
    id: 'st-michael',
    title: 'Prayer to St. Michael',
    category: 'Devotional Prayers',
    text: [
      'St. Michael the Archangel, defend us in battle. Be our defense against the wickedness and snares of the Devil. May God rebuke him, we humbly pray, and do thou, O Prince of the heavenly hosts, by the power of God, thrust into hell Satan, and all the evil spirits, who prowl about the world seeking the ruin of souls.',
      'Amen.',
    ],
  },
  {
    id: 'prayer-to-holy-spirit',
    title: 'Prayer to the Holy Spirit',
    category: 'Basic Prayers',
    text: [
      'Come, Holy Spirit, fill the hearts of Your faithful.',
      'And kindle in them the fire of Your love.',
      '',
      'V. Send forth Your Spirit and they shall be created.',
      'R. And You shall renew the face of the earth.',
      '',
      'Let us pray.',
      'O, God, who by the light of the Holy Spirit, did instruct the hearts of the faithful, grant that by the same Holy Spirit we may be truly wise and ever enjoy His consolations.',
      'Through Christ Our Lord.',
      'Amen.',
    ],
  },
  {
    id: 'act-of-faith',
    title: 'Act of Faith',
    category: 'Devotional Prayers',
    text: [
      'O my God, I firmly believe that you are one God in three divine Persons, Father, Son, and Holy Spirit. I believe that your divine Son became man and died for our sins, and that he will come to judge the living and the dead. I believe these and all the truths which the holy Catholic Church teaches, because you have revealed them, who can neither deceive nor be deceived.',
      'Amen.',
    ],
  },
  {
    id: 'act-of-hope',
    title: 'Act of Hope',
    category: 'Devotional Prayers',
    text: [
      'O my God, relying on your infinite goodness and promises, I hope to obtain pardon of my sins, the help of your grace, and life everlasting, through the merits of Jesus Christ, my Lord and Redeemer.',
      'Amen.',
    ],
  },
  {
    id: 'act-of-love',
    title: 'Act of Love',
    category: 'Devotional Prayers',
    subtitle: 'Act of Charity',
    text: [
      'O my God, I love you above all things, with my whole heart and soul, because you are all-good and worthy of all love. I love my neighbor as myself for the love of you. I forgive all who have injured me, and ask pardon of all whom I have injured.',
      'Amen.',
    ],
  },
  {
    id: 'prayer-of-st-francis',
    title: 'Prayer of St. Francis',
    category: 'Devotional Prayers',
    subtitle: 'Peace Prayer',
    text: [
      'Lord, make me an instrument of your peace.',
      'Where there is hatred, let me sow love;',
      'where there is injury, pardon;',
      'where there is doubt, faith;',
      'where there is despair, hope;',
      'where there is darkness, light;',
      'where there is sadness, joy.',
      '',
      'O divine Master, grant that I may not so much seek to be consoled as to console;',
      'to be understood as to understand;',
      'to be loved as to love.',
      'For it is in giving that we receive;',
      'it is in pardoning that we are pardoned;',
      'and it is in dying that we are born to eternal life.',
      'Amen.',
    ],
  },
  {
    id: 'rosary-joyful',
    title: 'Joyful Mysteries',
    category: 'Rosary',
    subtitle: 'Mondays & Saturdays',
    text: [
      '1. The Annunciation',
      '2. The Visitation',
      '3. The Nativity',
      '4. The Presentation in the Temple',
      '5. The Finding in the Temple',
    ],
  },
  {
    id: 'rosary-sorrowful',
    title: 'Sorrowful Mysteries',
    category: 'Rosary',
    subtitle: 'Tuesdays & Fridays',
    text: [
      '1. The Agony in the Garden',
      '2. The Scourging at the Pillar',
      '3. The Crowning with Thorns',
      '4. The Carrying of the Cross',
      '5. The Crucifixion',
    ],
  },
  {
    id: 'rosary-glorious',
    title: 'Glorious Mysteries',
    category: 'Rosary',
    subtitle: 'Wednesdays & Sundays',
    text: [
      '1. The Resurrection',
      '2. The Ascension',
      '3. The Descent of the Holy Spirit',
      '4. The Assumption',
      '5. The Coronation of the Blessed Virgin Mary',
    ],
  },
  {
    id: 'rosary-luminous',
    title: 'Luminous Mysteries',
    category: 'Rosary',
    subtitle: 'Thursdays',
    text: [
      '1. The Baptism of the Lord',
      '2. The Wedding at Cana',
      '3. The Proclamation of the Kingdom',
      '4. The Transfiguration',
      '5. The Institution of the Eucharist',
    ],
  },
  {
    id: 'grace-before-meals',
    title: 'Grace Before Meals',
    category: 'Daily Prayers',
    text: [
      'Bless us, O Lord, and these thy gifts, which we are about to receive from thy bounty, through Christ our Lord.',
      'Amen.',
    ],
  },
  {
    id: 'grace-after-meals',
    title: 'Grace After Meals',
    category: 'Daily Prayers',
    text: [
      'We give thee thanks, almighty God, for all thy benefits, who livest and reignest forever and ever.',
      'Amen.',
    ],
  },
  {
    id: 'guardian-angel',
    title: 'Guardian Angel Prayer',
    category: 'Daily Prayers',
    text: [
      'Angel of God, my guardian dear,',
      'to whom God\'s love commits me here,',
      'ever this day be at my side,',
      'to light and guard, to rule and guide.',
      'Amen.',
    ],
  },
  {
    id: 'morning-offering',
    title: 'Morning Offering',
    category: 'Daily Prayers',
    text: [
      'O Jesus, through the Immaculate Heart of Mary, I offer you my prayers, works, joys, and sufferings of this day, for all the intentions of your Sacred Heart, in union with the Holy Sacrifice of the Mass throughout the world, in reparation for my sins, and for the intentions of the Holy Father.',
      'Amen.',
    ],
  },
  {
    id: 'stations-of-the-cross',
    title: 'Stations of the Cross',
    category: 'Devotional Prayers',
    subtitle: 'Opening Prayer',
    text: [
      'Presider: We adore you, O Christ, and we praise you.',
      'All: Because by your holy cross you have redeemed the world.',
    ],
    closing: [
      'Presider: Lord Jesus Christ, your passion and death is the sacrifice that redeemed the world. As we have journeyed with you from station to station, help us to understand more fully the immense love you have shown us. Grant that we may imitate your example of sacrifice and love, and so come to share in your resurrection.',
      'All: Amen.',
    ],
  },
];
